// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CurrentExamState } from "../../utils/types";

const initialState: CurrentExamState = {
  state: "idle",
  isAllAnswered: false,
};

const ongoingExamSlice = createSlice({
  name: "completeExam",
  initialState,
  reducers: {
    setOngoingExamStatus: (
      state,
      action: PayloadAction<CurrentExamState["state"]>
    ) => {
      state.state = action.payload;
    },
    setIsAllAnswered: (
      state,
      action: PayloadAction<CurrentExamState["isAllAnswered"]>
    ) => {
      state.isAllAnswered = action.payload;
    },
  },
});

export const { setOngoingExamStatus, setIsAllAnswered } =
  ongoingExamSlice.actions;
export default ongoingExamSlice.reducer;
